const dev = {
	API_ENDPOINT_URL: `${typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000'}/contabilidade/api`,
	PUBLIC_PREFIX_PATH: "",
};

const prod = {
	API_ENDPOINT_URL:
		"https://contadash-back-to-front-twwgs.ondigitalocean.app/contabilidade/api",
	PUBLIC_PREFIX_PATH: "",
};

const test = {
	API_ENDPOINT_URL: "",
	PUBLIC_PREFIX_PATH: "/contabilidade",
};

const getEnv = () => {
	switch (process.env.REACT_APP_ENV) {
		case "development":
			return dev;
		case "production":
			return prod;
		case "test":
			return test;
		default:
			return dev;
	}
};

export const env = getEnv();
